import { Routes } from '@angular/router';

import { ROUTE_NAMES } from '@constants';
import {
  i18nWithProjectRoomRedirectResolver,
  userBeanResolver,
} from 'src/app/core/resolvers';

export const recentRoutes: Routes = [
  {
    path: 'recent',
    title: 'WEB_HOME_RECENT',
    resolve: {
      agorai18n: i18nWithProjectRoomRedirectResolver,
      userBean: userBeanResolver,
    },
    loadComponent: () =>
      import('./pages/recent.component').then((m) => m.RecentComponent),
    data: { navigationRoute: ROUTE_NAMES.RECENT },
  },
];
